import {farmerReducer}  from "../reducers/FarmerInfoReducer";

export const addFarmerInfo = (farmer_info) => async (dispatch) => {
    dispatch(farmerReducer(farmer_info));
};
  